import React from "react";

const BottomFooter = () => {
  const currentYear = new Date().getFullYear(); // Get current year dynamically
  return (
    <div className="bottom-footer bg-color-one">
      <div className="container container-lg">
        <div className="bottom-footer__inner flex flex-wrap gap-16  justify-center items-center">
          <p className="bottom-footer__text text-center text-sm">
            Copyright © {currentYear}. Bigmall PLC All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
